import * as React from "react";
import styled, { css } from "styled-components";
import { Colors } from "app/styling/colors";
import { Animations } from "app/styling/animations";

interface ViewProps {
  size: number;
}
interface SquareProps extends ViewProps {
  color: string;
}
const View = styled.div`
  ${(props: ViewProps) => css`
    position: relative;
    :not(:first-child) {
      margin-left: 10px;
    }
    .loader-spinner {
      .inside {
        animation: 1.5s ease-in-out forwards ${Animations.SHINE} infinite;
        animation-delay: 0.5s;
        box-shadow: 0px 19px 20px 0px rgba(0, 0, 0, 0.3);
        position: absolute;
        top: ${props.size / 3.333 + "px"};
        left: calc(${props.size / 3.333 + "px"});
      }
      .outside {
        animation: 1.5s ease-in-out forwards ${Animations.SHINE} infinite;
        width: 0px;
        height: 0px;
        border-top: ${props.size + "px"} solid ${Colors.QWILT_YELLOW_DIM};
        border-bottom: ${props.size + "px"} solid ${Colors.QWILT_GREEN_DIM};
        border-left: ${props.size + "px"} solid ${Colors.QWILT_BLUE_DIM};
        border-right: ${props.size + "px"} solid ${Colors.QWILT_RED_DIM};
        transform: rotate(45deg);
      }
    }
  `};
`;
const Square = styled.div`
  ${(props: SquareProps) => css`
    height: ${props.size - props.size / 3.333 + "px"};
    width: ${props.size - props.size / 3.333 + "px"};
    float: left;
    background-color: ${props.color}
    }
  `};
`;
interface Props {
  size: number;
}

interface State {}

export default class QwiltLogo extends React.Component<Props, State> {
  render() {
    return (
      <View size={this.props.size}>
        <div className="loader-spinner">
          <div className="outside" />
          <div className="inside">
            <div className="row">
              <Square size={this.props.size} color={Colors.QWILT_BLUE_BRIGHT} />
              <Square size={this.props.size} color={Colors.QWILT_YELLOW_BRIGHT} />
            </div>
            <div className="row">
              <Square size={this.props.size} color={Colors.QWILT_GREEN_BRIGHT} />
              <Square size={this.props.size} color={Colors.QWILT_RED_BRIGHT} />
            </div>
          </div>
        </div>
      </View>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/QwiltLogo.tsx